import {LoginContext} from 'components/LoginContext'
import React, {useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import _ from "lodash"
import {AdminOnlyNotice} from './AdminOnlyNotice'

// `notice` (opt-in, mặc định false — không đổi hành vi các chỗ đang dùng): khi bật, thêm
// AdminOnlyNotice phía trên children để chính admin cũng thấy rõ đây là phần chỉ mình họ
// nhìn thấy, user khác sẽ không có. Dùng cho gate cấp SECTION (danh sách, khối nội dung) —
// không dùng cho gate 1 icon/nút nhỏ (banner sẽ vỡ layout).
const RequiredAdmin = ({children, type, notice = false, renderEmpty = NullAsDefault}) => {
  const login = useContext(LoginContext)
  const {edit_system = false} = login ?? {}
  const renderChildren = () => notice ? (
    <>
      <AdminOnlyNotice className="mx-3 mb-2"/>
      {children}
    </>
  ) : children
  if (!edit_system) {
    if (login && type) {
      if (_.get(login, 'permission_roles.' + type, false)) {
        return renderChildren()
      }
    }
    return renderEmpty()
  }
  return renderChildren()
}

export const SystemPermission = ({children, system}) => {
  const login = useContext(LoginContext)
  const {edit_system = false} = login ?? {}
  return children(edit_system)
};

export const RequiredSystemAdmin = (props) => (
  <RequiredAdmin
    {...props}
    system={true}
  />
)

export default RequiredAdmin
